import React, { Component } from 'react';

export class Rules extends Component {
    render() {
        return (
            <h1>Rules</h1>
        );
    }
}